import { render } from "./Order.vue?vue&type=template&id=3b0600d2&scoped=true&bindings={\"onChangeTab\":\"setup\",\"goTo\":\"setup\",\"goBack\":\"setup\",\"onLoad\":\"setup\",\"onRefresh\":\"setup\"}"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=3b0600d2&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3b0600d2"

export default script